import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
var FieldGroup = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin-bottom: 14px;\n  display: flex;\n  flex-direction: ", ";\n"], ["\n  width: 100%;\n  margin-bottom: 14px;\n  display: flex;\n  flex-direction: ", ";\n"])), function (props) { return props.layout; });
FieldGroup.defaultProps = {
    layout: 'column',
};
export default FieldGroup;
var templateObject_1;
